"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerQuestionsModel = void 0;
const undef_filter_1 = require("./utils/undef-filter");
const question_1 = require("./question");
const locale_1 = require("./utils/locale");
const abTestingService_1 = require("./services/abTestingService");
const capitalizeFirstLetter_1 = require("./utils/capitalizeFirstLetter");
const boolean_1 = require("./utils/boolean");
const _1 = require(".");
const locale_2 = require("./utils/locale/locale");
class ServerQuestionsModel {
    affiliateService = new _1.AffiliateService();
    UW_Chunk = false; // for agents - to not show/ apply new errors to them until its false
    additionalBoats = [];
    questions = [];
    sections = [];
    questionnaireId;
    questionnaireStatus = '';
    layoutGrouping = {};
    userType = 'customer';
    isDev = (process.env.NODE_ENV && ['development', 'local'].includes(process.env.NODE_ENV)) || this.getQuestionById('watercraft_name')?.value === 'ahoy-testing-state';
    // in dev all states are returned for sell and rate. Otherwise, only the states that are allowed to sell and rate by date are returned
    stateDateInfo = [
    // { state: "NJ", dateAllowedSell: new Date("2030-04-05"), dateAllowedRate: new Date("2030-04-05")},
    ];
    // Please block the following manufacturers from binding in admitted product. They are all eligible for the E&S product based on the general rules
    blockedBoatManufacturers = ['ELIMINATOR BOATS', 'FOUNTAIN POWERBOATS', 'CIGARETTE RACING TEAM', 'SKATER - DOUGLAS MARINE', 'MAGIC POWER BOATS', 'NOR-TECH BY HPBC INC.', 'DONZI MARINE', 'SHOCKWAVE', 'NAVIER', 'CANDELA', 'INGENITY', 'XSHORE', 'ARCBOAT', 'ADVANTAGE BOATS', 'HALLETT BY BARRON BOATS', 'CONQUEST BOATS', 'BAJA BOATS', 'ADVANTAGE BOATS'];
    // Per-make model blocklist. If the application's make matches a key here AND
    // its model contains (case-insensitive substring) 
    blockedBoatModelsByMake = {
        'FORMULA BY THUNDERBIRD': ['fastech', 'fas3tech', 'sr-1'],
    };
    isBlockedByModelForMake(make, model) {
        if (typeof make !== 'string' || typeof model !== 'string' || !make || !model)
            return false;
        const blocked = this.blockedBoatModelsByMake[make];
        if (!blocked || blocked.length === 0)
            return false;
        const modelLower = model.toLowerCase();
        return blocked.some((token) => modelLower.includes(token.toLowerCase()));
    }
    getAllowedStatesByDate({ isSell = false }) {
        // return all states for dev mode
        if (this.isDev) {
            const stateInfoDataAllStates = this.stateDateInfo.reduce((acc, { state }) => {
                acc.push(state);
                return acc;
            }, []);
            return isSell ? { allowedSellStatesByDate: stateInfoDataAllStates } : { allowedRateStatesByDate: stateInfoDataAllStates };
        }
        const today = new Date();
        const allowedStatesByDate = this.stateDateInfo.reduce((acc, { state, dateAllowedSell, dateAllowedRate }) => {
            if (today >= (isSell ? dateAllowedSell : dateAllowedRate)) {
                acc.push(state);
            }
            return acc;
        }, []);
        return isSell ? { allowedSellStatesByDate: allowedStatesByDate } : { allowedRateStatesByDate: allowedStatesByDate };
    }
    allowedSellStatesByDate = this.getAllowedStatesByDate({ isSell: true })?.allowedSellStatesByDate || [];
    allowedRateStatesByDate = this.getAllowedStatesByDate({})?.allowedRateStatesByDate || [];
    allowedSellStates = [
        ...this.allowedSellStatesByDate,
        'AZ', 'AR', 'CA', 'DC', 'DE', 'MA',
        'GA', 'IA', 'ID', 'IL', 'IN', 'LA',
        'KS', 'OH', 'PA', 'ME', 'MI', 'NJ',
        'MO', 'MN', 'NC', 'ND', 'NE', 'NM',
        'NY', 'NV', 'RI', 'SD', 'SC', 'TN',
        'UT', 'VT', 'WI', 'WV', 'MD', 'KY',
        'NH', 'CT', 'MT', 'CO', 'WY', 'VA',
        'TX', 'OR', 'OK', 'AL', 'FL', 'WA',
        'MS',
    ];
    allowedSellStatesDemoMode = [];
    allowedRateStates = [
        ...this.allowedRateStatesByDate,
        ...this.allowedSellStates,
    ];
    init(rawData, isMobile = false, overrides = {}, questions = []) {
        const lockAll = rawData.questionnaireStatus === 'Completed';
        const paymentSuccessful = rawData.questions.find((q) => {
            return q.questionId === 'Payment_Instructions_Created';
        });
        if (paymentSuccessful?.value === '$_BOOL_true') {
            this.questionnaireStatus = 'Payment';
        }
        else {
            this.questionnaireStatus =
                rawData.questionnaireStatus == 'Inactive' ? 'Mem' : rawData.questionnaireStatus || 'Mem';
        }
        if (isMobile) {
            this.layoutGrouping = rawData.layoutGroupingMobile || {};
        }
        else {
            this.layoutGrouping = rawData.layoutGrouping || {};
        }
        // allocate new data
        this.questionnaireId = rawData.questionnaireId || this.questionnaireId;
        if (questions.length == 0) {
            const rawQuestions = rawData.questions || [];
            this.questions = (0, undef_filter_1.undefFilter)(rawQuestions.map((rawQuestion) => {
                const question = (0, question_1.createQuestionFromRaw)(rawQuestion, overrides, rawData);
                if (question) {
                    question.locked = (question.locked ?? false) || lockAll;
                }
                return question;
            }));
        }
        else {
            this.questions = questions;
        }
        this.sections = (rawData.sections.flat() || []).map((sectionId) => ({
            sectionId,
            blocks: [],
        }));
        Object.entries(this.layoutGrouping || {}).forEach(([name]) => {
            const section = this.sections.find((s) => s.sectionId === name);
            if (section) {
                const blocks = (this.layoutGrouping || {})[name]?.map((b) => {
                    return { questionIds: b[0].questions.flat().map((q) => q.split('::')[0]) };
                });
                section.blocks = blocks;
            }
        });
        this.joinField('UBUBBI_Limit_per_person', 'UBUBBI_Limit_per_occurrence', 'UBUBBI_Limit');
        this.joinField('BI_Limit_per_person', 'BI_Limit_per_occurrence', 'BI_Limit');
        this.additionalBoats = rawData.additionalBoats || [];
    }
    joinField(fld1, fld2, join) {
        const fld1Value = this.getQuestionById(fld1)?.value || '';
        const fld2Value = this.getQuestionById(fld2)?.value || '';
        const val = fld1Value && fld2Value ? fld1Value + '/' + fld2Value : '';
        const question = this.getQuestionById(join);
        if (question) {
            question.value = val;
        }
    }
    getUW_Chunk() {
        return this.UW_Chunk;
    }
    getQuestionnaireId() {
        return this.questionnaireId || '';
    }
    getSections() {
        return this.sections;
    }
    getFirstSection() {
        return this.sections[0].sectionId;
    }
    getBlocksBySection(sectionId) {
        return this.getSectionById(sectionId)?.blocks || [];
    }
    getQuestionById(id) {
        return this.questions.find((q) => q.questionId === id.toString());
    }
    getQuestionsValues(questionIds) {
        const arr = questionIds.map((qId) => {
            const val = this.getQuestionById(qId)?.value ?? null;
            return [qId, val];
        });
        return Object.fromEntries(arr) || {};
    }
    getQuestionsObjects(questionIds) {
        const arr = questionIds.map((qId) => {
            const val = this.getQuestionById(qId) ?? null;
            return [qId, val];
        });
        return Object.fromEntries(arr) || {};
    }
    getQuestionsBySection(sectionId) {
        const section = this.getSectionById(sectionId);
        if (section) {
            return section.blocks
                .map((block) => block.questionIds)
                .flat()
                .map((qId) => this.getQuestionById(qId));
        }
        throw new Error(`Section ${sectionId} not found`);
    }
    getSectionById(sectionId) {
        return this.sections.find((s) => s.sectionId === sectionId);
    }
    getStatus() {
        return this.questionnaireStatus;
    }
    isNew() {
        return this.questionnaireStatus == 'New';
    }
    getQuestions() {
        return this.questions;
    }
    getLayoutGrouping(sectionId) {
        return this.layoutGrouping[sectionId || ''] || [];
    }
    getLayoutGroupingInternal() {
        return this.layoutGrouping;
    }
    getAdditionalBoatsCount() {
        return this.additionalBoats.length;
    }
    getValue(qId) {
        const question = this.getQuestionById(qId);
        return question?.value;
    }
    getTestValue(name) {
        const abtests_q = this.getQuestionById(abTestingService_1.AbTestingService.QID);
        return abTestingService_1.AbTestingService.getTestValueInner(name, abtests_q);
    }
    // this number is the one displayed in lh-dropdown for actual calling
    getAgentPhoneNumber() {
        const { affiliateService } = this;
        return this.userType === 'externalAgent' ? affiliateService.getExternalAgentPhoneNumber() : affiliateService?.getAgentNumber();
    }
    // this number is the text display in the UW error message
    getSupportNumber() {
        const { affiliateService } = this;
        return this.userType === 'externalAgent' ? affiliateService?.getExternalAgentSupportNumber() : affiliateService?.getSupportNumber();
    }
    getSupportPhoneNumberText() {
        return `<br>${this.getSupportNumber()}`;
    }
    //rat3
    getManufactureYearAsAge() {
        let response = 'old';
        // we pass true for the getBoatAge method to "grandfather" MTA apps. It doesn't grandfather Renewals since the Sold_date is empty on Renewals.
        const boatAge = this.getBoatAge(true) || 0;
        const agreedValueLimit = 20;
        // if the boat doesn't exist in PD, we allow only Actual Cash Value (old), unless the is Approved Value
        // and the boat value is equal to the Approved Value or below it
        const approvedValue = this.getQuestionById('Approved_Boat_Value')?.value;
        const boatValue = this.getQuestionById('value')?.value;
        const isBoatValueUnderOrEqualToApprovedValue = !!(boatValue && approvedValue && (boatValue <= approvedValue));
        const isOtherBoatModel = this.getQuestionById('otherBoatModel')?.value === '$_BOOL_true';
        // we're moving to manual override for agents to allow coverages selection. If boat value is higher than price digest value,
        // we allow only Actual Cash Value (old) coverage. To override it and allow Agreed Value (return "middle"), UW_Error_38 override
        // code needs to be set. To override and allow Replacement Cost (return "new"), UW_Error_39 override code needs to be set.
        const isAgreedValueOverride = !this.overrideUWrule('UW_Error_38');
        const isReplacementCostOverride = !this.overrideUWrule('UW_Error_39');
        const priceDigestValue = this.getQuestionById('priceDigestValue')?.value || 0;
        const isValueHigherThanPriceDigest = (boatValue && priceDigestValue && (boatValue > priceDigestValue));
        // const noOverrideUsed = !isAgreedValueOverride && !isReplacementCostOverride;
        const otherBoatModelWithNoApprovedValue = isOtherBoatModel && !isBoatValueUnderOrEqualToApprovedValue;
        if (otherBoatModelWithNoApprovedValue
        // || (noOverrideUsed && isValueHigherThanPriceDigest)
        ) {
            return 'old';
        }
        switch (true) {
            case (boatAge <= 2 || (isValueHigherThanPriceDigest && isReplacementCostOverride)):
                response = 'new';
                break;
            case ((boatAge > 2 && boatAge < agreedValueLimit) || (isValueHigherThanPriceDigest && isAgreedValueOverride)):
                response = 'middle';
                break;
            case boatAge >= agreedValueLimit:
                response = 'old';
                break;
            default:
                response = 'old';
        }
        return response;
    }
    // this is called both from coherentDataService and the UI, to solve an issue in which these fields - that show up in an email to the customer -
    // were not updated on changing package selection whereas they were saved on new rate from coherentDataService.
    // email fields: Total_Premium_Annual, Down_Payment_Amount, Installment_Amount
    getDownpaymentInstallmentAndTotalAmounts({ premium, MTA_rating_fix = 0, effective_date }) {
        let installments = 0;
        let monthlyPayment = 0;
        let downPayment = 0;
        let installment = 0;
        const totalPremium = premium['monthly-amount'] + MTA_rating_fix;
        ;
        let expiration_date = new _1.DateValue(effective_date);
        expiration_date.addYears(1);
        const currentDate = new Date();
        const left_months = Math.floor((expiration_date.toEpoc() * 1000 - currentDate.getTime()) / (1000 * 3600 * 24 * 31));
        if (left_months >= 2) {
            installments = left_months - 1;
            if (installments > 10) {
                installments = 10;
            }
            monthlyPayment = Math.round(totalPremium / (installments + 2));
        }
        installment = monthlyPayment;
        downPayment = totalPremium - (installments * monthlyPayment);
        const Total_Premium_Monthly = premium?.['monthly-amount'] + MTA_rating_fix;
        const Total_Premium_Annual = premium?.['annual-amount'] + MTA_rating_fix;
        return { downPayment, installment, Total_Premium_Monthly, Total_Premium_Annual, installments };
    }
    getCoverageTypes() {
        const coveragesQuestion = this.getQuestionById('Physical_Damage_Settlement_option');
        const { coverageByBoatAgeType } = coveragesQuestion.metadata;
        const coverageOpts = coverageByBoatAgeType[this.getManufactureYearAsAge()] || [];
        const rawOpts = coveragesQuestion.metadata.coverageOptions;
        const allOptions = rawOpts.map((o) => o.split('::')).map(([label, value]) => ({ label, value }));
        // const boatType = this.getQuestionById('boatType')?.value;
        let availableOptions;
        // if (boatType == 'Personal Watercraft') { commented out due to https://ahoy-insure.atlassian.net/browse/US-3521
        // availableOptions = allOptions.filter((o) => o.value == 'Actual Cash Value');
        // } else {
        availableOptions = allOptions.filter((o) => coverageOpts.includes(o.value));
        // }
        return availableOptions;
    }
    getSettlementOptionForRenewal() {
        const coveragesValue = this.getQuestionById('Physical_Damage_Settlement_option')?.value;
        const validCoverages = this.getCoverageTypes();
        if (!validCoverages.find((i) => i.value == coveragesValue)) {
            switch (coveragesValue) {
                case 'Replacement Cost':
                    if (validCoverages.find((i) => i.value == 'Agreed Value')) {
                        return 'Agreed Value';
                    }
                    else {
                        return 'Actual Cash Value';
                    }
                case 'Agreed Value':
                    return 'Actual Cash Value';
            }
        }
        return coveragesValue;
    }
    validateSection({ section, validateBoatValue = false, validateMinBoatValue = false, validateValueQuestionInsteadOfOverrideQuestion = false }) {
        if (section == 'S_Boat_Details') {
            let { priceDigestValue, overrideValue, value, userDefinedBoatValue, Approved_Boat_Value, Approved_Min_Boat_Value, manufacture_year } = this.getQuestionsValues([
                'priceDigestValue',
                'overrideValue',
                'value',
                'userDefinedBoatValue',
                'Approved_Boat_Value',
                'Approved_Min_Boat_Value',
                'manufacture_year',
            ]);
            // boat value mandatory error
            const boatValue = value || overrideValue || 0;
            if (!boatValue || boatValue <= 0) {
                return { value: false, errorCode: 'ValidErrValueMandatory', field: 'value' };
            }
            // min boat value validation
            // not in use anymore since the this logic was moved to underwriting error 52B
            if (validateMinBoatValue) {
                // userDefinedBoatValue is true when the user has entered the boat value manually, meaning the value, which is also the price digest value at this point - is 0.
                // overrideValue is the value the user has entered manually.
                // show warning(like exceed boat value) if:
                // 1. manual boat value is lower than 50 % of price digest value display warning
                // 2. if no price digest - 
                //  - if boat year after 2005 and Manual boat value < 5000$ and manual boat value < approve_min_boat_value 
                //  - if boat year before 2005 and Manual boat value < 1500$ and manual boat value < approve_min_boat_value 
                // we remove the userDefinedBoatValue check because the value can be altered also when the config is found on PriceDigest, in this case the userDefinedBoatValue is false
                // on validating when validateValueQuestionInsteadOfOverrideQuestion = true, this means the userDefinedBoatValue is true, and the value of the value question is the value that needs validation
                // for min value
                if (validateValueQuestionInsteadOfOverrideQuestion || overrideValue === 0)
                    overrideValue = value;
                // to return to US-3045 functionality - override PD values under 1500 w 1500 for boats before 2005, 5000 after -
                // 1. delete the if on the next line and its closing bracket,
                // 2. delete the "else" from the "else if" below. leave the "if" as is.
                if (!priceDigestValue) {
                    // check for min boat value
                    const manufactureYearAfter2005 = manufacture_year > 2005;
                    const overrideBoatValueLessThan5000 = overrideValue < 5000;
                    const overrideValueLessThan1500 = overrideValue < 1500;
                    Approved_Min_Boat_Value = Approved_Min_Boat_Value || overrideValue + 1;
                    if (((manufactureYearAfter2005 && overrideBoatValueLessThan5000) || overrideValueLessThan1500) && (overrideValue < Approved_Min_Boat_Value) && this.overrideUWrule('ValidMinOverrideValue')) {
                        return { value: false, errorCode: 'ValidMinOverrideValue', field: 'overrideValue' };
                    }
                }
                // to return to US-3045 functionality, delete the "else" only, leave the "if"
                else if (overrideValue < priceDigestValue * 0.5) {
                    Approved_Min_Boat_Value = Approved_Min_Boat_Value || overrideValue + 1;
                    if ((overrideValue < Approved_Min_Boat_Value) && this.overrideUWrule('ValidMinOverrideValue')) {
                        return { value: false, errorCode: 'ValidMinOverrideValue', field: 'overrideValue' };
                    }
                }
            }
            // max boat value validation
            // not in use anymore since the this logic was moved to underwriting error 52B
            if (validateBoatValue) {
                // first we check if the value is below or equal to the approved value if defined. If so, no error and the user can continue
                if (Approved_Boat_Value && overrideValue <= Approved_Boat_Value) {
                    return { value: true, errorCode: '', field: '' };
                }
                // this scenario is when the boat configuration is found on PriceDigest and the user didn't define all the boat params himself (userDefinedBoatValue flag).
                // if no approved value was defined, we check if the value is over the 1.15 * price digest value. If so, return error
                if (!boolean_1.BooleanValue.toNative(userDefinedBoatValue) &&
                    priceDigestValue &&
                    overrideValue > priceDigestValue * 1.15) {
                    return { value: false, errorCode: 'ValidOverrideValue', field: 'overrideValue' };
                }
            }
        }
        return { value: true, errorCode: '', field: '' };
    }
    validateForRating(stage, { isPaymentLinkMode = false } = {}) {
        const driverAfterPricing = 'after_pricing_DEPRECIATED' === abTestingService_1.AbTestingService.getTestValueInner('driver', { value: this.getValue(abTestingService_1.AbTestingService.QID) });
        let validateSections = ['S_Welcome', 'S_Boat', 'S_Boat_Details', 'S_Address', 'S_Owner'];
        if (!driverAfterPricing || stage == 'billing') {
            validateSections = [...validateSections, 'S_Driver'];
        }
        if (stage == 'customization' || stage == 'billing') {
            validateSections = [...validateSections, 'S_Pricing_Customization'];
        }
        if (stage == 'billing') {
            validateSections = [...validateSections, 'S_Boater', 'S_Boat_Garage', 'S_Trailer', 'S_Additional_Boaters'];
        }
        // validating UW rules per each section
        for (const section of validateSections) {
            const error = this.validateUW(section);
            if (!error.value) {
                return { value: false, err: (0, locale_2.t)(error.errorCode, error.param), field: '', section: section, errorCodeForLastError: error.errorCode };
            }
        }
        const questions = this.getQuestionsBySections(validateSections);
        const nonValidQuestion = questions.find((q) => {
            const question = this.getQuestionById(q.qId);
            // In paymentLinkMode, we skip validating the Boat_Attestation_Initials question,
            // because if it's invalid, it masks other invalid questions.
            // For example, if length question value is empty (length 0), validation will fail early on Boat_Attestation_Initials,
            // and length question incorrect value won't be detected.
            // This causes the UI to incorrectly load the payment link page instead of showing a non-closing popup.
            if (question && question.questionId === 'Boat_Attestation_Initials' && isPaymentLinkMode) {
                return false;
            }
            if (question) {
                const validator = question.validator;
                const value = question.value || '';
                const hide = question.isHide ? question.isHide(this.getValue.bind(this)) : false;
                validator?.validate(value);
                return (validator?.errors || []).length > 0 && !hide;
            }
            else {
                return false;
            }
        });
        if (nonValidQuestion) {
            const question = this.getQuestionById(nonValidQuestion.qId);
            let errCode = question?.validator?.errors[0].message || '';
            // add metadata to the error message
            //eslint-disable-next-line no-unsafe-optional-chaining
            if (question?.validator?.errors[0].meta) {
                errCode = (0, locale_1.ts)(errCode, ...question?.validator?.errors[0].meta);
            }
            const errMessage = question?.text ? (0, locale_1.ts)(question.text) + ': ' + (0, locale_1.ts)(errCode) : (0, locale_1.ts)(errCode);
            const section = nonValidQuestion.section == 'S_Boat_Details'
                ? 'S_Boat'
                : nonValidQuestion.section == 'S_Pricing_Customization'
                    ? 'S_Pricing'
                    : nonValidQuestion.section;
            return { value: false, err: errMessage, field: question?.questionId || '', section: section, errorCodeForLastError: 'Fields' };
        }
        else {
            //questions valid,  adding liability validation      
            const validateLiability = () => {
                const errObject = { value: false, err: '', field: '', section: 'S_Pricing', errorCodeForLastError: '' };
                const isValidString = (value) => {
                    return value !== null && value !== undefined && typeof value === 'string';
                };
                const { UBUBBI_Limit_per_person, BI_Limit_per_person, UBUBBI_Limit_per_occurrence, BI_Limit_per_occurrence, UBUIBPD_Limit, PD_Limit_per_occurrence, } = this.getQuestionsObjects([
                    'UBUBBI_Limit_per_person', 'BI_Limit_per_person',
                    'UBUBBI_Limit_per_occurrence', 'BI_Limit_per_occurrence',
                    'UBUIBPD_Limit', 'PD_Limit_per_occurrence',
                ]);
                if (isValidString(UBUBBI_Limit_per_person?.value) && isValidString(BI_Limit_per_person?.value) &&
                    parseInt(UBUBBI_Limit_per_person.value, 10) > parseInt(BI_Limit_per_person.value, 10)) {
                    errObject.err = `${(0, locale_2.t)(UBUBBI_Limit_per_person.text)} must be less than or equal to ${(0, locale_2.t)(BI_Limit_per_person.text)}`;
                    errObject.errorCodeForLastError = 'ValidateLiabilityError';
                    return errObject;
                }
                if (isValidString(UBUBBI_Limit_per_occurrence?.value) && isValidString(BI_Limit_per_occurrence?.value) &&
                    parseInt(UBUBBI_Limit_per_occurrence.value, 10) > parseInt(BI_Limit_per_occurrence.value, 10)) {
                    errObject.err = `${(0, locale_2.t)(UBUBBI_Limit_per_occurrence.text)} must be less than or equal to ${(0, locale_2.t)(BI_Limit_per_occurrence.text)}`;
                    errObject.errorCodeForLastError = 'ValidateLiabilityError';
                    return errObject;
                }
                if (isValidString(UBUIBPD_Limit?.value) && isValidString(PD_Limit_per_occurrence?.value) &&
                    parseInt(UBUIBPD_Limit.value, 10) > parseInt(PD_Limit_per_occurrence.value, 10)) {
                    errObject.err = `${(0, locale_2.t)(UBUIBPD_Limit.text)} must be less than or equal to ${(0, locale_2.t)(PD_Limit_per_occurrence.text)}`;
                    errObject.errorCodeForLastError = 'ValidateLiabilityError';
                    return errObject;
                }
                return null;
            };
            if (stage === 'customization' || stage === 'billing') {
                const notValidResponse = validateLiability();
                if (notValidResponse) {
                    return notValidResponse;
                }
            }
            const validSection = this.validateSection({ section: 'S_Boat_Details', validateBoatValue: false });
            if (!validSection.value) {
                return {
                    value: false,
                    err: (0, locale_1.ts)(validSection.errorCode, this.getSupportPhoneNumberText()),
                    field: validSection.field,
                    section: 'S_Boat',
                    errorCodeForLastError: validSection.errorCode,
                };
            }
            else {
                return { value: true, err: '', field: '', section: '', errorCodeForLastError: '' };
            }
        }
    }
    getQuestionsBySections(validateSections) {
        const result = validateSections
            .map((s) => this.getLayoutGrouping(s)
            .flat()
            .map((b) => b.questions)
            .flat()
            .flat()
            .map((l) => {
            return { qId: l.split('::')[0], section: s };
        }))
            .flat();
        const innerQuestions = [];
        for (const q of result) {
            const question = this.getQuestionById(q.qId);
            if (question && question.fielddata) {
                const fd = question.fielddata;
                for (const innerQuestionName of Object.keys(fd)) {
                    innerQuestions.push({ qId: innerQuestionName, section: q.section });
                }
            }
        }
        result.push(...innerQuestions);
        return result;
    }
    getBoatDisplayName() {
        const watercraftName = this.getQuestionById('watercraft_name').value || '';
        const manufacturerName = (0, capitalizeFirstLetter_1.capitalizeFirstLetter)(this.getQuestionById('make')?.value) || '';
        return watercraftName ? watercraftName : manufacturerName ? 'your ' + manufacturerName : (0, locale_1.ts)('your boat');
    }
    getCheckByState() {
        const { Calculated_State } = this.getQuestionsValues(['Calculated_State']);
        return Calculated_State;
    }
    isMaxPolicyLimitReached() {
        const { is_max_policy_limit } = this.getQuestionsValues(['is_max_policy_limit']);
        return is_max_policy_limit === '$_BOOL_true';
    }
    setUserType(userType) {
        this.userType = userType;
    }
    setCustomerType(state, _allowedToSellAgent, _allowedToSellAgency) {
        let allowedToSell = this.allowedSellStates.includes(state);
        let allowedToRate = this.allowedRateStates?.includes(state);
        const previousCustomerType = this.getCustomerType();
        //demo mode
        if (this.isTestApp()) {
            allowedToSell = this.allowedSellStates.includes(state) || this.allowedSellStatesDemoMode.includes(state);
        }
        let customerType;
        if (allowedToRate && allowedToSell)
            customerType = 'Type1';
        if (allowedToRate && !allowedToSell)
            customerType = 'Type2';
        if (!allowedToRate && !allowedToSell)
            customerType = 'Type3';
        this.getQuestionById('Application_Type').value = customerType;
        return customerType != previousCustomerType;
    }
    getCustomerType() {
        return this.getQuestionById('Application_Type')?.value;
    }
    isTestApp(suffix) {
        let { watercraft_name } = this.getQuestionsValues(['watercraft_name']);
        if (!watercraft_name) {
            return false;
        }
        else {
            watercraft_name = watercraft_name.toString().toLowerCase();
        }
        const suffixCond = !suffix || watercraft_name.endsWith(suffix.toLowerCase());
        return (watercraft_name.startsWith('ahoy-testing') || watercraft_name.startsWith('ahoy-demo')) && suffixCond;
    }
    /**
     * This function is used to check if a sticker needs to be displayed on the payment button.
     * The sticker is displayed if the boat name is "ahoy-testing" and the app is in test mode.
     * @returns {sticker} - sticker object with value and side
     */
    checkNoBilling() {
        const checkWatercraftName = ({ watercraft_name }) => {
            if (!watercraft_name) {
                return false;
            }
            else {
                watercraft_name = watercraft_name.toString().toLowerCase();
            }
            return watercraft_name.startsWith('ahoy-testing');
        };
        let { watercraft_name, IsTest } = this.getQuestionsValues(['watercraft_name', 'IsTest']);
        const isAhoyTesting = checkWatercraftName({ watercraft_name });
        const isTestApp = IsTest && boolean_1.BooleanValue.toNative(IsTest) || false;
        const sticker = { show: isTestApp, type: isAhoyTesting ? 'left' : 'right' };
        return { sticker };
    }
    overrideUWrule(errorCode) {
        const override_UW_rules = this.getQuestionById('override_UW_rules').value || '';
        const override_UW_rules_Arr = override_UW_rules.split(',').map((i) => i.trim());
        if (override_UW_rules_Arr.includes(errorCode)) {
            return false;
        }
        return true;
    }
    getBoatAge(fromSoldDate = false) {
        const { manufacture_year, sold_date } = this.getQuestionsValues(['manufacture_year', 'sold_date']);
        const today = new Date();
        const referToSoldDate = sold_date && fromSoldDate;
        const currentYear = referToSoldDate ? new Date(sold_date).getFullYear() : today.getFullYear();
        // Determine if the current date is on or after October 1. check the sold date if fromSoldDate is true
        const isAfterOctober1 = referToSoldDate ? new Date(sold_date).getMonth() >= 9 : today.getMonth() >= 9; // October is month index 9
        // The model year changes effective October 1
        const modelYear = isAfterOctober1 ? currentYear + 1 : currentYear;
        // Boat age is calculated as the difference between model year and manufacture year
        const boatAge = manufacture_year ? modelYear - parseInt(manufacture_year) : undefined;
        return boatAge;
    }
    // Proactive yacht-program check — mirrors the three conditions in
    // validateUWforNewYachtProgram but returns a plain boolean. Unlike
    // validateUWforNewYachtProgram (which is an error-message rewriter that
    // needs a triggering originalErrCode), this can be called at any time to
    // ask "would this boat qualify for the yacht program if some UW check
    // failed?". Used by the FE's DL-section-placement logic to decide whether
    // to keep the driver license section before or after pricing.
    boatQualifiesForYachtProgram() {
        const { boatAge, length, value, boatType, max_speed } = {
            ...this.getQuestionsValues(['length', 'boatType', 'value', 'max_speed']),
            boatAge: this.getBoatAge(true) || 0,
        };
        const isSpeedBoat = max_speed > 90;
        return ((boatType !== 'Houseboat' && value > 350000 && value <= 3000000 && boatAge <= 40 && length <= 95) ||
            (boatType === 'Houseboat' && boatAge <= 30 && value > 500000) ||
            (isSpeedBoat && boatAge <= 40 && value > 100000 && value <= 3000000 && length <= 95));
    }
    //new yacht program check
    validateUWforNewYachtProgram({ previousSections, originalErrCode }) {
        const supportNumber = '<br>1-855-289-2469';
        const { boatAge, length, value, boatType, max_speed } = {
            ...this.getQuestionsValues(['length', 'boatType', 'value', 'max_speed']),
            boatAge: this.getBoatAge(true) || 0,
        };
        if (!previousSections.includes('S_Boat')) {
            return { value: true, errorCode: '' };
        }
        const isSpeedBoat = max_speed > 90;
        const conditions = [
            { condition: boatType != 'Houseboat' && value > 350000 && value <= 3000000 && boatAge <= 40 && length <= 95, errorCode: originalErrCode?.includes('_Yacht') ? originalErrCode : `${originalErrCode}_Yacht` },
            { condition: boatType === 'Houseboat' && boatAge <= 30 && value > 500000, errorCode: originalErrCode?.includes('_Yacht') ? originalErrCode : `${originalErrCode}_Yacht` },
            { condition: isSpeedBoat && boatAge <= 40 && value > 100000 && value <= 3000000 && length <= 95, errorCode: originalErrCode?.includes('_Yacht') ? originalErrCode : `${originalErrCode}_Yacht` },
        ];
        for (const { condition, errorCode } of conditions) {
            if (condition) {
                return { value: false, errorCode, param: supportNumber };
            }
        }
        return { value: true, errorCode: '' };
    }
    // new yacht program check will be called if the model check fails
    validateUW(currentSection) {
        if (['S_Welcome'].includes(currentSection))
            return { value: true, errorCode: '' };
        const { make, model, length, boatType, value, hullType, motorType, horsepower, numberOfEngine, Number_of_Owners, Is_MTA, Last_Premium, New_Rating_Premium, Is_Renewal, boating_experience, boat_purchase_date, Physical_Damage_Settlement_option, Number_of_Claims } = this.getQuestionsValues(['make', 'model', 'length', 'boatType', 'value', 'hullType', 'motorType', 'horsepower', 'numberOfEngine', 'Number_of_Owners', 'Is_MTA', 'Last_Premium', 'New_Rating_Premium', 'Is_Renewal', 'boating_experience', 'boat_purchase_date', 'Physical_Damage_Settlement_option', 'Number_of_Claims']);
        const isAgent = !!this.getQuestionById('External_Agent')?.value;
        const shouldApplyNewErrorsToAgent = isAgent ? (this.UW_Chunk ? false : true) : true;
        const maxPolicyLimitReached = this.isMaxPolicyLimitReached();
        const supportNumber = this.getSupportPhoneNumberText();
        const boatAge = this.getBoatAge(true) || 0;
        const checkByState = this.getCheckByState();
        const previousSections = this.getSections().slice(0, this.getSections().findIndex((s) => s.sectionId == currentSection) + 1).map((s) => s.sectionId);
        const MTArateChanged = Is_MTA == '$_BOOL_true' && New_Rating_Premium && Last_Premium != New_Rating_Premium && this.overrideUWrule('MTA_Rating_Change');
        if (previousSections.includes('S_Welcome')) {
            if (MTArateChanged) {
                return { value: false, errorCode: 'MTA_Rating_Change' };
            }
        }
        if (previousSections.includes('S_Boat')) {
            // the blocked boat manufactures rule should not be applied to mta instances
            if (this.blockedBoatManufacturers.includes(make) && this.overrideUWrule('UW_Error_41') && (Is_MTA !== '$_BOOL_true'))
                return { value: false, errorCode: 'UW_Error_41', param: supportNumber };
            // Per-make model blocklist: same UW_Error_41 binding-block when the make
            // is on the blockedBoatModelsByMake list and the model contains any of
            // the listed substrings (case-insensitive).
            if (this.isBlockedByModelForMake(make, model) && this.overrideUWrule('UW_Error_41') && (Is_MTA !== '$_BOOL_true'))
                return { value: false, errorCode: 'UW_Error_41', param: supportNumber };
            if (boatAge > 30 && this.overrideUWrule('UW_Error_40'))
                return { value: false, errorCode: 'UW_Error_40', param: supportNumber };
            if (value > 500000 && boatType !== 'Personal Watercraft' && this.overrideUWrule('UW_Error_12'))
                return { value: false, errorCode: 'UW_Error_12', param: supportNumber };
            if (length > 50 && boatType !== 'Personal Watercraft' && this.overrideUWrule('UW_Error_2'))
                return { value: false, errorCode: 'UW_Error_2', param: supportNumber };
            if (shouldApplyNewErrorsToAgent && boatType === 'Personal Watercraft' && Is_MTA != '$_BOOL_true' && Is_Renewal != '$_BOOL_true' && this.overrideUWrule('UW_Error_45'))
                return { value: false, errorCode: 'UW_Error_45', param: supportNumber };
            if (boatAge > 40 && this.overrideUWrule('UW_Error_7'))
                return { value: false, errorCode: 'UW_Error_7', param: supportNumber };
            if (['Houseboat'].includes(boatType) && this.overrideUWrule('UW_Error_8'))
                return { value: false, errorCode: 'UW_Error_8', param: supportNumber };
            if (!['Pontoon'].includes(boatType) && boatAge > 30 && (length > 45 || value > 75000) && this.overrideUWrule('UW_Error_9'))
                return { value: false, errorCode: 'UW_Error_9' };
            if (numberOfEngine === 1 && horsepower > 500 && !['Skisurf'].includes(boatType) && this.overrideUWrule('UW_Error_4'))
                return { value: false, errorCode: 'UW_Error_4', param: supportNumber };
            if (numberOfEngine === 2 && horsepower > 1000 && !['Skisurf'].includes(boatType) && this.overrideUWrule('UW_Error_4'))
                return { value: false, errorCode: 'UW_Error_4', param: supportNumber };
            if (horsepower > 1050 && !['Skisurf'].includes(boatType) && this.overrideUWrule('UW_Error_5'))
                return { value: false, errorCode: 'UW_Error_5', param: supportNumber };
            if (numberOfEngine > 3 && this.overrideUWrule('UW_Error_6'))
                return { value: false, errorCode: 'UW_Error_6', param: supportNumber };
            if (motorType === 'Jet' && boatAge > 20 && length <= 21 && horsepower >= 250 && this.overrideUWrule('UW_Error_10'))
                return { value: false, errorCode: 'UW_Error_10', param: supportNumber };
            if (horsepower > 565 && ['Skisurf'].includes(boatType) && this.overrideUWrule('UW_Error_11'))
                return { value: false, errorCode: 'UW_Error_11', param: supportNumber };
            if (boatType === 'Other' && this.overrideUWrule('UW_Error_21'))
                return { value: false, errorCode: 'UW_Error_21', param: supportNumber };
            if (motorType === 'Other' && this.overrideUWrule('UW_Error_21'))
                return { value: false, errorCode: 'UW_Error_21', param: supportNumber };
            if ((hullType === 'Other' || hullType === 'Iron' || hullType === 'Wood') && this.overrideUWrule('UW_Error_21'))
                return { value: false, errorCode: 'UW_Error_21', param: supportNumber };
            if (((boatAge < 5 && value < 5000) || (value < 1500)) && this.overrideUWrule('UW_Error_53') && Is_MTA != '$_BOOL_true') {
                return { value: false, errorCode: 'UW_Error_53', param: supportNumber };
            }
            if (Number_of_Claims > 1 && this.overrideUWrule('UW_Error_47')
                && Is_MTA != '$_BOOL_true') {
                return { value: false, errorCode: 'UW_Error_47', param: supportNumber };
            }
            if (shouldApplyNewErrorsToAgent && Is_MTA != '$_BOOL_true' && Is_Renewal != '$_BOOL_true' && (boatType === 'Pontoon' && (value < 15000 || value > 100000)) && this.overrideUWrule('UW_Error_50'))
                return { value: false, errorCode: 'UW_Error_50', param: supportNumber };
        }
        if (previousSections.includes('S_Address')) {
            if (hullType === 'Aluminum' && ['CA', 'CO', 'ID', 'MT', 'OR', 'UT', 'WA'].includes(checkByState) && motorType === 'Jet' && this.overrideUWrule('UW_Error_15'))
                return { value: false, errorCode: 'UW_Error_15', param: supportNumber };
            if (['FL'].includes(checkByState) && Is_MTA != '$_BOOL_true' && Is_Renewal != '$_BOOL_true' && this.overrideUWrule('UW_Error_57'))
                return { value: false, errorCode: 'UW_Error_57', param: supportNumber };
            if ((boatAge > 35 || value > 350000) && ['FL'].includes(checkByState) && this.overrideUWrule('UW_Error_16'))
                return { value: false, errorCode: 'UW_Error_16', param: supportNumber };
            if (maxPolicyLimitReached && value > 400000 && this.overrideUWrule('UW_Error_34'))
                return { value: false, errorCode: 'UW_Error_34', param: supportNumber };
            if (shouldApplyNewErrorsToAgent && ['NH', 'NJ'].includes(checkByState) && Is_MTA != '$_BOOL_true' && Is_Renewal != '$_BOOL_true' && this.overrideUWrule('UW_Error_44'))
                return { value: false, errorCode: 'UW_Error_44' };
        }
        if (previousSections.includes('S_Owner')) {
            if (Number_of_Owners === 'More')
                return { value: false, errorCode: 'UW_Error_22', param: supportNumber };
            if (shouldApplyNewErrorsToAgent && Is_MTA != '$_BOOL_true' && Is_Renewal != '$_BOOL_true' && (horsepower > 400 && boating_experience < 5) && this.overrideUWrule('UW_Error_49'))
                return { value: false, errorCode: 'UW_Error_49', param: supportNumber };
            if (shouldApplyNewErrorsToAgent && Is_MTA != '$_BOOL_true' && Is_Renewal != '$_BOOL_true' && (boatType === 'CabinCruiser' && boating_experience < 5) && this.overrideUWrule('UW_Error_48'))
                return { value: false, errorCode: 'UW_Error_48', param: supportNumber };
        }
        if (previousSections.includes('S_Pricing') || previousSections.includes('S_MTA_Coverages')) {
            const validCoverages = this.getCoverageTypes();
            const coveragesQuestion = this.getQuestionById('Physical_Damage_Settlement_option');
            if (!validCoverages.find((i) => i.value == coveragesQuestion?.value) && this.overrideUWrule('InvalidCoverage')) {
                return { value: false, errorCode: 'InvalidCoverage' };
            }
        }
        if (previousSections.includes('S_Boater') && currentSection !== 'S_Boater') {
            // && currentSection !== 'S_Boater' is for an edge case where the user goes back and induces one of the 2 errors below which causes the user to be unable to move forward unless the user goes back to 'pricing and packages and chooses actual cash value 
            if (shouldApplyNewErrorsToAgent && Is_Renewal != '$_BOOL_true' && boat_purchase_date === 'Over 3 years ago' && Physical_Damage_Settlement_option === 'Agreed Value' && this.overrideUWrule('UW_Error_54')) {
                return { value: false, errorCode: 'UW_Error_54', param: supportNumber };
            }
            if (shouldApplyNewErrorsToAgent && Is_MTA != '$_BOOL_true' && Is_Renewal != '$_BOOL_true' && (boat_purchase_date === 'Over 3 years ago' || boat_purchase_date === '1 year to 3 years ago') && Physical_Damage_Settlement_option === 'Replacement Cost' && this.overrideUWrule('UW_Error_55')) {
                return { value: false, errorCode: 'UW_Error_55', param: supportNumber };
            }
        }
        return { value: true, errorCode: '' };
    }
    getZohoInput(_questionnaireOwnerId, _questionnaireLayout) {
        const multipleAdditionalDestinationFieldNames = new Map([['External_Agent', ['Created_By_Agent']]]);
        const result = {};
        this.questions.forEach((question) => {
            const remoteFieldName = question.remoteField;
            if (remoteFieldName) {
                const resolvedValue = this.changeValuesToBooleanOrNull(question.value);
                if (resolvedValue !== undefined) {
                    result[remoteFieldName] = resolvedValue;
                    if (multipleAdditionalDestinationFieldNames.has(remoteFieldName)) {
                        const additionalDestinationFieldNames = multipleAdditionalDestinationFieldNames.get(remoteFieldName);
                        additionalDestinationFieldNames.forEach((additionalDestinationFieldName) => {
                            result[additionalDestinationFieldName] = resolvedValue;
                        });
                    }
                }
            }
        });
        return result;
    }
    changeValuesToBooleanOrNull(val) {
        let newVal = val;
        if (['$_BOOL_true', '$_BOOL_false', '$_NULL'].includes(val)) {
            switch (val) {
                case '$_BOOL_true':
                    newVal = true;
                    break;
                case '$_BOOL_false':
                    newVal = false;
                    break;
                case '$_NULL':
                    newVal = null;
                    break;
            }
        }
        return newVal;
    }
}
exports.ServerQuestionsModel = ServerQuestionsModel;
